﻿let _ = require('lodash');

let ReplaceImgWithSvg = require('./ReplaceImgWithSvg');

module.exports = ThankYouMessage;

function ThankYouMessage({
    $element,
    donationData,
    responseObject    
}) {
    let designationName = donationData["designation.name"] ? ` for ${donationData["designation.name"]}` : '';
    let shareLink = getShareLink(designationName);

    let subTable = {
        "amount": donationData['other_amount'],
        "frequency": donationData['sustaining.frequency'],
        "designation": designationName,
        "billingFirstName": donationData["billing.name.first"],
        "billingLastName": donationData["billing.name.last"],
        "billingStreet1": donationData["billing.address.street1"],
        "billingStreet2": donationData["billing.address.street2"],
        "billingCity": donationData["billing.address.city"],
        "billingState": donationData["billing.address.state"],
        "billingZipcode": donationData["billing.address.zip"],
        "billingCountry": donationData["billing.address.country"],
        "billingEmail": donationData["donor.email"],
        "tributeHonoreeName": donationData['tribute.honoree.name.full'],
        "shippingNameFirst": donationData['shipping.name.first'],
        "shippingNameLast": donationData['shipping.name.last'],
        "shippingTitle": donationData['shipping.address.title'],
        "shippingStreet1": donationData['shipping.address.street1'],
        "shippingStreet2": donationData['shipping.address.street2'],
        "shippingCity": donationData['shipping.address.city'],
        "shippingZipcode": donationData['shipping.address.zip'],
        "shippingState": donationData['shipping.address.state'],
        "shippingCountry": donationData['shipping.address.country'],
    };

    subTable = _.transform(subTable, (result, value, key) => {
        result[key] = _.escape(value);
    });

    subTable.facebookShareLink = '<span class="orange-text facebook-share-button">Facebook</span>';
    
    const $content = $element.find('.thank-you-message-content');
    let messageTemplate = $content.html();

    _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
    const compiled = _.template(messageTemplate);
    const message = compiled(subTable);
    $content.html(message);

    $('#name-of-donor').html(donationData["billing.name.first"] + " " + donationData["billing.name.last"]);
    $('#thank-you-message-amount').html(donationData["other_amount"]);
    $('#thank-you-message-designation').html(designationName);

    $('#thank-you-name').html(donationData["billing.name.first"] + " " + donationData["billing.name.last"]);
    $('#thank-you-address-1').html(donationData["billing.address.street1"]);
    $('#thank-you-address-2').html(donationData["billing.address.street2"]);
    $('#thank-you-city').html(donationData["billing.address.city"]);
    $('#thank-you-state').html(donationData["billing.address.state"]);
    $('#thank-you-zip-code').html(donationData["billing.address.zip"]);
    $('#thank-you-country').html(donationData["billing.address.country"]);
    $('#thank-you-email').html(donationData["donor.email"]);
    $('#thank-you-amount').html(`$${donationData['other_amount']}`);

    if (responseObject) {
        $('.thank-you-transaction-details').show();
        $('#thank-you-tax-deductible-amount').html(responseObject.donationResponse.donation.tax_deductible_amount.formatted);
        $('#thank-you-confirmation-code').html(responseObject.donationResponse.donation.confirmation_code);
    }


    socialShare(shareLink);
}

function socialShare(shareLink) {
    var facebookShare = $('.facebook-share-button');
    var socialMediaShare = $('#social-media-share');

    $.ajaxSetup({ cache: true });
    $.getScript('//connect.facebook.net/en_US/sdk.js', function () {
        FB.init({
            appId: '493177397699054',
            version: 'v2.9' // or v2.1, v2.2, v2.3, ...
        });

        facebookShare.on('click', function () {

            FB.ui({
                method: 'share',
                href: shareLink
                }, function (response) {
                    console.log(arguments);
                });
        });
    });

    socialMediaShare.jsSocials({
        shares: [{
            share: "twitter",
            logo: "ResourcePackages/JNF/Mvc/Pictures/twitter-orange.svg",
            css: "svg",
            text: "",
            url: shareLink
        }, {
            share: "email",
            logo: "ResourcePackages/JNF/Mvc/Pictures/email-orange.svg",
            css: "svg",
            text: "I have just donated to JNF. You can do the same here:",
            shareIn: "blank"
        }],
        showLabel: false,
        showCount: false,
        shareIn: "popup",
    });
    let svgImages = $('img.svg, img.jssocials-share-logo');
    ReplaceImgWithSvg(svgImages);
}

function getShareLink(designationName) {
    const chosenShareImage = $('.fill-donate-form-picture').css('background-image').slice(4, -1).replace(/\"/gi, "");
    const description = encodeURIComponent(`I have just donated to JNF${designationName}. Join me in building a bright future for the land and people of Israel.`);
    const imageUrl = encodeURIComponent(chosenShareImage);
    const redirectUrl = encodeURIComponent(window.location.href)

    return `${jnfroutesconfg.FacebookMetaTags}/?description=${description}&imageurl=${imageUrl}&redirectUrl=${redirectUrl}`;
}
